import { render, staticRenderFns } from "./Authenticator.vue?vue&type=template&id=157e21ac&scoped=true&"
import script from "./Authenticator.vue?vue&type=script&lang=js&"
export * from "./Authenticator.vue?vue&type=script&lang=js&"
import style0 from "./Authenticator.vue?vue&type=style&index=0&id=157e21ac&prod&scoped=true&lang=scss&"
import style1 from "./Authenticator.vue?vue&type=style&index=1&id=157e21ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e21ac",
  null
  
)

export default component.exports